import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Observable, of as observableOf } from 'rxjs';
import { catchError, map, mergeMap } from 'rxjs/operators';

import {
  FetchListSubscriptionAction,
  FetchListSubscriptionFailedAction,
  FetchListSubscriptionSuccessAction,
  UpdateListSubscriptionAction,
  UpdateListSubscriptionFailedAction,
  UpdateListSubscriptionSuccessAction,
  UserSubscribedListsActionTypes,
} from './user-subscribed-lists.actions';
import { UserSubscribedListsService } from './user-subscribed-lists.service';

@Injectable()
export class UserSubscribedListsEffects {
  fetchListSubscriptionState$: Observable<
    FetchListSubscriptionSuccessAction | FetchListSubscriptionFailedAction
  > = createEffect(() =>
    this.actions$.pipe(
      ofType(UserSubscribedListsActionTypes.FETCH_LIST_SUBSCRIPTION),
      mergeMap((action: FetchListSubscriptionAction) => {
        const { userId, listId } = action.payload;
        return this.userSubscribedListsService
          .isInUserSubscribedLists(userId, listId)
          .pipe(
            map(
              isSubscribed =>
                new FetchListSubscriptionSuccessAction({
                  listId,
                  isSubscribed,
                }),
            ),
            catchError(error =>
              observableOf(
                new FetchListSubscriptionFailedAction({ error, listId }),
              ),
            ),
          );
      }),
    ),
  );

  addToUserSubscribedList$: Observable<
    UpdateListSubscriptionSuccessAction | UpdateListSubscriptionFailedAction
  > = createEffect(() =>
    this.actions$.pipe(
      ofType(UserSubscribedListsActionTypes.UPDATE_LIST_SUBSCRIPTION),
      mergeMap((action: UpdateListSubscriptionAction) => {
        const { userId, listId } = action.payload;
        return this.userSubscribedListsService
          .addToUserSubscribedLists(userId, listId)
          .pipe(
            map(
              isSubscribed =>
                new UpdateListSubscriptionSuccessAction({
                  listId,
                  isSubscribed,
                }),
            ),
            catchError(error =>
              observableOf(
                new UpdateListSubscriptionFailedAction({ error, listId }),
              ),
            ),
          );
      }),
    ),
  );

  constructor(
    private actions$: Actions,
    private userSubscribedListsService: UserSubscribedListsService,
  ) {}
}
